import React from 'react';
import './LoadingComponent.css';

const Loading = () => {
    return (
        <div className="loading-component">
            <div className="loader-content"></div>
        </div>
    );
};
export default Loading;